import { render } from "./BasicAnalysis.vue?vue&type=template&id=73833d1a"
import script from "./BasicAnalysis.vue?vue&type=script&lang=js"
export * from "./BasicAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__